import { Link } from "react-router-dom";
import { Gauge, MapPin, Tag, Lock } from "lucide-react";
import { Badge } from "./ui/badge";
import VinBadge from "./VinBadge";
import FinanceHint from "./FinanceHint";
import HeartButton from "./HeartButton";

const COND = { excellent: "text-emerald-300", good: "text-cyan-300", fair: "text-amber-300", needs_work: "text-red-300" };

export default function SaleCard({ listing: l, delay = 0 }) {
  return (
    <Link to={`/buy/${l.listing_id}`} data-testid={`sale-card-${l.listing_id}`} className="group block rise" style={{ animationDelay: `${delay}ms` }}>
      <div className="relative overflow-hidden rounded-2xl bg-[#131722] border border-slate-800 hover:border-amber-500/50 transition-all duration-500 hover:-translate-y-1">
        <div className="aspect-[4/3] relative overflow-hidden bg-slate-900">
          {l.photos?.[0] && <img src={l.photos[0]} alt={l.model} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />}
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-transparent to-transparent" />
          <div className="absolute top-3 left-3 flex gap-2">
            <Badge className="bg-amber-500/20 text-amber-300 border border-amber-500/30 backdrop-blur-md font-mono text-[10px] tracking-wider uppercase"><Tag className="w-3 h-3 mr-1" />For sale</Badge>
            {l.status === "reserved" && <Badge className="bg-slate-900/80 text-slate-200 border border-slate-700 backdrop-blur-md font-mono text-[10px] uppercase"><Lock className="w-3 h-3 mr-1" />Reserved</Badge>}
            {l.dealer_badge && <Badge className="bg-cyan-500/20 text-cyan-300 border border-cyan-500/30 backdrop-blur-md font-mono text-[10px] tracking-wider uppercase" data-testid={`badge-dealer-${l.listing_id}`}>Dealer</Badge>}
          </div>
          <div className="absolute top-3 right-3 flex items-center gap-2"><VinBadge report={l.vin_report} compact /><HeartButton listingId={l.listing_id} hearts={l.hearts} /></div>
        </div>
        <div className="p-5">
          <div className="flex items-start justify-between gap-3 mb-2">
            <div className="min-w-0">
              <h3 className="font-display font-bold text-lg leading-tight truncate">{l.year} {l.make}</h3>
              <p className="text-slate-400 text-sm truncate">{l.model} {l.trim && `· ${l.trim}`}</p>
            </div>
            <div className="text-right shrink-0"><p className="font-display font-extrabold text-xl text-white">${Number(l.asking_price).toLocaleString()}</p><FinanceHint amount={l.asking_price} compact testId={`finance-card-${l.listing_id}`} /></div>
          </div>
          <div className="flex items-center gap-4 text-xs text-slate-400">
            <span className="flex items-center gap-1"><Gauge className="w-3.5 h-3.5" />{Number(l.mileage).toLocaleString()} mi</span>
            <span className="flex items-center gap-1"><MapPin className="w-3.5 h-3.5" />{l.city}</span>
            <span className={`ml-auto capitalize font-mono ${COND[l.condition] || ""}`}>{l.condition.replace("_", " ")}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
